import { IGame } from "./../../entities";
import { provider } from "../../providers";

export interface GetGameByIdPayload {
  id: number;
}

export const GetGameById = async (params: GetGameByIdPayload): Promise<IGame | null> =>
  provider.Request("/games/{id}", params);
